/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MinimizeIcon = ({ width = 24, height = 24, hidden = false, title = 'Minimize' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32.077 2.707a1 1 0 0 0-1.414 0l-6.484 6.484L21.2 6.206A.688.688 0 0 0 20.705 6a.7.7 0 0 0-.7.7v8.84a.5.5 0 0 0 .459.459H29.3a.7.7 0 0 0 .7-.7.685.685 0 0 0-.207-.49l-2.984-2.984 6.484-6.484a1 1 0 0 0 0-1.414ZM15.541 20H6.7a.7.7 0 0 0-.7.7.685.685 0 0 0 .207.49l2.984 2.984-6.484 6.489a1 1 0 0 0 0 1.414l1.216 1.216a1 1 0 0 0 1.414 0l6.484-6.484 2.984 2.985A.688.688 0 0 0 15.3 30a.7.7 0 0 0 .7-.7v-8.84a.5.5 0 0 0-.459-.46Z"
    />
  </svg>`;
};
